module.exports = __webpack_public_path__ + "img/Vertical.bd625029.png";